export default __webpack_public_path__ + "static/media/x-twitter.746e8fa5.svg";